export default __webpack_public_path__ + "static/media/duns-number.466a1276.png";